/* eslint-disable react/sort-comp */
import React from 'react';
import PropTypes from 'prop-types';
import _throttle from 'lodash/throttle';

import streetBg4 from 'assets/png/street/04_Street_BG.png';
import streetMiddle from 'assets/png/street/03_street_middle.png';
import streetBg2 from 'assets/png/street/02_street_bg.png';
import streetBg1 from 'assets/png/street/01_street_bg.png';

import ForegroundItem from 'components/ForegroundItem';
import IntroPanel from 'components/IntroPanel';
import Infopanel from 'components/Infopanel';
import {
  Layer,
  BGImg,
  centerViewport as centerViewportFN,
  scroll as scrollFN,
  setBodyDimension as setBodyDimensionFN,
  scrollToPosition as scrollToPositionFN,
} from 'components/Parallax';
import SwitchViewButton from 'components/SwitchViewButton';

import { plx1, plx2, plx3 } from 'config/StreetConfig';
import { Mobile } from 'media';

import { CSSTransition } from 'react-transition-group';


class Street extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeItem: null,
      scrollPosition: props.position,
      showIntro: false,
    };

    this.throttledScroll = _throttle(this.scroll, 20, { leading: true, trailing: true });
  }

  componentDidMount() {
    this.bg.addEventListener('load', this.setBodyDimension); // is there a better react way ?
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.throttledScroll);
    this.props.savePosition(this.state.scrollPosition);
  }


  setBodyDimension = () => {
    setBodyDimensionFN(this.bg, this.props.scrollMode, () => {
      if (this.props.centerOnInit) {
        // Workaround: in chrome/safaru a scrollTo while (re)loading the page does not work and a old scrollTop may
        // still be set
        setTimeout(this.centerViewport, 900);
      } else {
        this.scrollToPosition();
      }
    });
  }

  centerViewport = () => {
    centerViewportFN(() => {
      this.setState({ scrollPosition: 50, showIntro: this.props.showIntro });
      // we don't want to catch the first event triggered by the scrollTo
      setTimeout(this.addScrollHandler, 1);
    });
  }

  scrollToPosition = () => {
    scrollToPositionFN(this.state.scrollPosition);
    this.setState({ showIntro: false });
    this.addScrollHandler();
  }

  addScrollHandler = () => {
    window.addEventListener('scroll', this.throttledScroll, false);
  }

  scroll = () => {
    scrollFN((pos) => {
      this.setState({ scrollPosition: pos, showIntro: false });
    });
  }

  /* probably should be part of a config helper or even better, there would be a single config object */
  getItemFromConfig(itemId) {
    let item = plx3[itemId];
    if (!item) {
      item = plx2[itemId];
    }
    if (!item) {
      item = plx1[itemId];
    }
    return item;
  }


  handleToggleItem = (id) => {
    this.setState((previousState) => ({
      activeItem: (id === previousState.activeItem ? null : id),
    }));
  }
  handleClosePanel = () => {
    this.setState({ activeItem: null });
  }


  renderStoreButtons = () => (
    <React.Fragment>
      <SwitchViewButton label="Raum betreten" onClick={this.props.onEnterMachinesRoom} top={67} left={27.1} />
      <SwitchViewButton label="Wir haben geöffnet" onClick={this.props.onEnterClothingStore} top={67} left={42.1} />
      <SwitchViewButton label="Wir haben geöffnet" onClick={this.props.onEnterFoodStore} top={67} left={59.28} />
    </React.Fragment>
  );

  renderParallaxChildren = (items) => Object.keys(items).map((i) => (
    <ForegroundItem
      key={i}
      id={i}
      item={items[i]}
      isActive={this.state.activeItem === i}
      toggleItem={this.handleToggleItem}
      closePanel={this.handleClosePanel}
    />
  ));

  render() {
    const item = this.getItemFromConfig(this.state.activeItem);

    return (
      <div>
        <Layer position={this.state.scrollPosition}>
          <BGImg src={streetBg4} minWidth />
        </Layer>

        <Layer position={this.state.scrollPosition}>
          <BGImg src={streetMiddle} innerRef={(el) => { this.bg = el; }} />
          {this.renderParallaxChildren(plx3)}
          {this.renderStoreButtons()}
        </Layer>

        <Layer position={this.state.scrollPosition} ignoreEvents>
          <BGImg src={streetBg2} />
          {this.renderParallaxChildren(plx2)}
        </Layer>

        <CSSTransition
          in={this.state.activeItem === null}
          timeout={750}
          classNames="hidelayer"
        >
          {/* div is needed, because transition classes are set on it. if removed, the effect is removed when scrolling */}
          <div>
            <Layer position={this.state.scrollPosition} ignoreEvents>
              <BGImg src={streetBg1} />
              {this.renderParallaxChildren(plx1)}
            </Layer>
          </div>
        </CSSTransition>

        <Mobile>
          {item &&
          <Infopanel
            id={item.id}
            onClose={this.handleClosePanel}
            alignX={item.infopanel.overlay.x}
            alignY={item.infopanel.overlay.y}
            title={item.infopanel.content.title}
            description={item.infopanel.content.description}
            link={item.infopanel.content.link}
          />
          }
        </Mobile>

        <IntroPanel show={this.state.showIntro} />
      </div>
    );
  }
}

Street.propTypes = {
  onEnterClothingStore: PropTypes.func.isRequired,
  onEnterFoodStore: PropTypes.func.isRequired,
  onEnterMachinesRoom: PropTypes.func.isRequired,
  showIntro: PropTypes.bool,
  savePosition: PropTypes.func.isRequired,
  position: PropTypes.number,
  centerOnInit: PropTypes.bool,
  scrollMode: PropTypes.string,
};

Street.defaultProps = {
  position: 0,
  showIntro: false,
  centerOnInit: false,
  scrollMode: 'vertical',
};

export default Street;



// WEBPACK FOOTER //
// ./src/components/Street/Street.js